import FlowDiagramNode from '@/ecm/models/workflow/FlowDiagramNode';
import FlowDiagramTransition from '@/ecm/models/workflow/FlowDiagramTransition';
import { FlowTransitionTypes } from './FlowConstants';
export default class FlowDiagram {
    constructor (dto) {
        this.flowName = '';
        this.flowId = 0;
        this.nodes = [];
        this.connections = [];

        if (dto) {
            this.flowId = dto.FlowId;
            this.flowName = dto.FlowName;
            const nodes = dto.States.map(x => new FlowDiagramNode(x, dto.Transitions));
            const connections = dto.Transitions.map(x => new FlowDiagramTransition(x));
            this.nodes = nodes;
            this.connections = connections;
        }
    }

    buildFrom(states) {
        const nodes = states.map((s) => {
            return {
                id: s.id,
                name: s.description,
                approvers: [{ name: '' }]
            };
        });

        const connections = states.flatMap((s) =>
            s.transitions.map((t) => {
                return {
                    id: s.id,
                    type: t.transitionType === FlowTransitionTypes.Validate ? 'Validate' : 'Refuse',
                    source: { id: s.id },
                    destination: { id: t.stateTo },
                };
            }));
            this.nodes = nodes;
            this.connections = connections;

    }
}